import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import store from '../../../store';

import type {
  IRootDispatch,
} from '../../../store/models';

import type {
  MarketingVideosSlot,
  MarketingVideosSlots,
} from '../../../store/MarketingVideos/MarketingVideos.model';

export function useMarketingVideos(slotName: MarketingVideosSlots): MarketingVideosSlot {
  const dispatch = useDispatch<IRootDispatch>();
  const checkedSlotName = React.useRef<{ [key: string]: true }>({});
  const videoData: MarketingVideosSlot = useSelector(store.select.marketingVideos.bySlotName({
    slotName,
  }));

  React.useEffect(() => {
    if (!videoData && !checkedSlotName.current[slotName]) {
      dispatch.marketingVideos.loadSlot(slotName);
      checkedSlotName.current[slotName] = true;
    }
  }, [slotName, videoData, dispatch.marketingVideos]);

  return videoData;
}
